import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { TranslationModule } from '../../../../i18n/translation.module';
import { ShareModule } from '../../../../shared/share.module';
import { PagesSharedModule } from '../../pages-shared.module';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
    TranslationModule,
    ShareModule,
    PagesSharedModule,
  ],
  exports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
    TranslationModule,
    ShareModule,
    PagesSharedModule,
  ],
})
export class BaseFormModule {}
